import { httpFetch } from "../../Utils/httpUtils";
import { packageActionTypes as actionTypes } from "../../ActionTypes/Voss/packageActionTypes";
import { commonActionTypes } from "../../ActionTypes/commonActionTypes";
import formActions from "../formActions";
import forms from "../../Constants/forms";

const packageActions = {

    getPackages: () => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "packages", value: true });
            return httpFetch(`/api/packages/`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_PACKAGES, data: json });
                })
                .finally(() => dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "packages", value: false }))
        }
    },

    getPackage: (id, versionId) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "package", value: true });
            return httpFetch(`/api/packages/${id}${versionId ? `?versionId=${versionId}` : ''}`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_PACKAGE, data: json });
                })
                .finally(() => dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "package", value: false }))
        }
    },

    getOffer: (id, customerId) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "offer", value: true });
            return httpFetch(`/api/offers/offer/${id}?customerId=${customerId}`, dispatch)
                .then(json => {
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "offer", value: false });
                    dispatch({ type: actionTypes.STORE_OFFER, data: json });
                })
        }
    },

    getPackageNames: () => {
        return (dispatch) => {
            return httpFetch(`/api/packages/GetPackageNames`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_PACKAGE_NAMES, data: json });
                })
        }
    },

    getProductNames: () => {
        return (dispatch) => {
            return httpFetch(`/api/packages/GetProductNames`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_PRODUCT_NAMES, data: json });
                })
        }
    },

    beginPriceAdjustmentForm: (packageId, versionId) => {
        return (dispatch) => {
            dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "priceAdjustmentForm", value: true });
            return httpFetch(`/api/packages/${packageId}/priceadjustments/editform?versionId=${versionId}`, dispatch)
                .then(json => {
                    dispatch(formActions.startFormEditing(forms.priceAdjustmentFormData, json, null));
                    dispatch({ type: commonActionTypes.SET_DATA_LOADING, key: "priceAdjustmentForm", value: false });
                })
        }
    },

    getPackageVersions: (packageId) => {
        return (dispatch) => {
            return httpFetch(`/api/packages/${packageId}/versions`, dispatch)
                .then(json => {
                    dispatch({ type: actionTypes.STORE_PACKAGE_VERSIONS, data: json });
                })
        }
    },

    clear: (key) => {
        return (dispatch) => {
            dispatch({ type: actionTypes.CLEAR, key });
        }
    },

    reset() {
        return {
            type: actionTypes.RESET
        }
    },
};

export default packageActions;
